/**
 * @generated SignedSource<<a6a5d483d5b8e049f767f04c88a83fe1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizMainContainerHeader_theme",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizViewModeSwitch_theme"
    }
  ],
  "type": "Theme",
  "abstractKey": null
};

node.hash = "22de7bd40780f226c38b59fb751202e6";

module.exports = node;
